var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('eAnonymComplModal',_vm._b({on:{"snackbar-msg":function($event){return _vm.mxfSendParent('snackbar-msg', $event)},"close":_vm.fGoToDetail}},'eAnonymComplModal',_vm.cProp,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }